
import React from "react";
import { Database } from "lucide-react";

interface DatabaseBadgeProps {
  isInitialized: boolean;
}

const DatabaseBadge: React.FC<DatabaseBadgeProps> = ({ isInitialized }) => {
  if (!isInitialized) return null;
  
  return (
    <span className="ml-2 text-xs bg-green-100 text-green-800 rounded-full px-2 py-1 flex items-center shadow-sm">
      <Database className="h-3 w-3 mr-1" />
      Database gesynchroniseerd
    </span>
  );
};

export default DatabaseBadge;
